import Component from '../../js/lib/component';

const classList = {
  root: '.js-counter',
  remove: '.js-counter-remove',
  field: '.js-counter-field',
  add: '.js-counter-add'
};

export default class Counter extends Component {
  init() {
    this.state.count = Number(this.$.field.val());
  }
  events() {
    this.$.remove.on('click', () => {
      this.decrease();
      this.validate();
      this.render();
    });
    this.$.add.on('click', () => {
      this.increase();
      this.validate();
      this.render();
    });
    this.$.field.on('change', () => {
      this.state.count = Number(this.$.field.val());
      this.validate();
      this.render();
    });
  }
  decrease() {
    this.state.count = this.state.count - 1;
  }
  increase() {
    this.state.count = this.state.count + 1;
  }
  validate() {
    if (this.state.count < 2 || isNaN(this.state.count)) {
      this.state.count = 1;
    }
  }
  render() {
    this.$.field.val(this.state.count);
  }
}

Component.mount(Counter, {
  name: 'Counter',
  classList,
  state: { count: 0 }
});
